import axios from "axios";

export const accessToken = "pk.eyJ1IjoiYW5kZXJzd2kiLCJhIjoiY2sxeXZpajg2MGppZDNpbGk0M2k4Ymd1MiJ9.ivUORoF2V8BwTAbi3RTbjQ"; 
const disableCache = true;

export function getMapboxData(id:string) {
	const params:any = { access_token: accessToken };
	if(disableCache)
		params.r = Math.random();
	
	return axios.get(`https://api.mapbox.com/datasets/v1/anderswi/${id}/features`, {params});
		
}